import * as React from 'react';
import { vars, mixin, css, classNames } from '@src/services/theme';

// typing
interface Props {
	className?: string;
	bg?: string;
	needle?: string;
	value: number;
	min?: number;
	max?: number;
}


// style
const style = css`
	position: relative;
	display: inline-block;
`;

const styleNeedle = css`
	position: absolute;
	${mixin.center}
	transform-origin: 14px 60px;
`

// component
export default class GaugeCustom extends React.Component<Props> {

	render() {
		const { className, bg = 'default', needle = 'default', value, min = 0, max = 100 } = this.props;

		const angle = { min: 56, max: 302 };
		const unit = (value - min) / (max - min);
		var rotation = ((angle.max - angle.min) * unit) + angle.min;
		var status = bg;

		if (value == null) {
			rotation = 180;
		}
		if (bg == 'soh') {
			if (value > 45) {
				status += 'GREEN';
			} else if (value <= 35) {
				status += 'RED';
			}
		}
		if (bg== 'balancing'){
			if (value>=2.5 || value <=-2.5){
				status +='RED';
			} else if (value>=1.7|| value <=-1.7){
				status+='YELLOW';
			}
		}

		const styleRotation = {
			transform: `translate(-50%, -50%) rotate(${rotation}deg)`
		}

		return (
			<div
				className={classNames(
					'gauge-custom',
					style,
					className,
				)}
			>
				<img src={`/files/gauge/${status}.png`} />
				<img src={`/files/gauge/${needle}.png`} className={styleNeedle} style={styleRotation} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/UI/GaugeCustom.tsx